import { getAIHook } from '@openclassrooms/data-connect-web/utils';

const useEnhanceMotivation = getAIHook({
  promptCode: 'enhance-cover-letter',
  serverName: 'ai-api-user',
});

export default useEnhanceMotivation;
